import { useClaimProperties } from 'all-in-one-shared-api';
import { useEffect } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';

export const initialState = {};

export const useCachedClaimProperties = (key: string) => {
  const { ready, token, tokenParsed } = useKeycloakReady();
  const { data, shouldFetch, mutate } = useClaimProperties(key, token ?? '', {
    shouldRetryOnError: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false,
    onSuccess: (d) => {
      const { familyMembers, claimTypes } = d;
      const userToken = tokenParsed;
      if ((familyMembers ?? []).length == 0 && userToken) {
        d.familyMembers = [
          {
            memberType: userToken.memberType,
            firstName: userToken.given_name,
            lastName: userToken.family_name,
          },
        ];
      }

      if ((claimTypes ?? []).length == 0) {
        d.claimTypes = [];
      }
    },
  });

  useEffect(() => {
    if (ready) shouldFetch(true);
    return () => {
      if (data) shouldFetch(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, shouldFetch]);

  return { data, mutate };
};
